import styled from '@emotion/styled';

import ClassicDefaultImg from 'assets/banners/action-defi-banner-large.png';
import DealDefaultImg from 'assets/banners/action-deal-banner-large.png';
import ListDefaultImg from 'assets/banners/action-list-banner-large.png';
import PhotoDefaultImg from 'assets/banners/action-photo-banner-large.png';
import { ICustomTheme, ChallengeTypeType } from 'interfaces';
import { CHALLENGE } from 'constants/challenges';

type Theme = {
  theme?: ICustomTheme;
};

const banners = {
  [CHALLENGE.CLASSIC]: ClassicDefaultImg,
  [CHALLENGE.DEAL]: DealDefaultImg,
  [CHALLENGE.LIST]: ListDefaultImg,
  [CHALLENGE.PHOTO]: PhotoDefaultImg,
};

export const Banner = styled.div<{
  theme: ICustomTheme;
  type: ChallengeTypeType;
}>(({ theme, type }) => ({
  backgroundColor: theme.palette.grey[300],
  backgroundImage: `url(${banners[type]})`,
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  height: theme.layout.widgets.actionBannerHeight,
  position: 'relative',
}));

export const Container = styled.div(() => ({
  flex: '1 0 auto',
}));

export const PageContainer = styled.div<Theme>(({ theme }) => ({
  padding: theme.spacing(11),
}));
